import React from 'react';
import './App.css';
import Header from './components/header';
import Board from './components/board';
import Control from './components/control';
import Footer from './components/footer';
import DarkModeToggle from './components/DarkModeToggle';

function App() {
  return (
    <div className="App">
      <Header />
      <DarkModeToggle />
      <div className="main-content-wrapper" style={{ 
        width: '100%', 
        display: 'flex', 
        justifyContent: 'center',
        padding: '0 10px', /* 减少左右内边距 */
        boxSizing: 'border-box'
      }}>
        <div className="game-container">
        <Board />
        <Control />
      </div>
    </div>
      <Footer />
    </div>
  );
}

export default App;
